module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/hospital_list/img_doctor04-78f14be8d609b219a25a9b4d54141085.png";